/**
 * BottomBar component that mimics a status bar.
 * Displays development environment indicators including connection status,
 * version control information, sync status, and error/warning counts.
 * 
 * @component
 * @returns {JSX.Element} Fixed bottom status bar with development indicators
 */
function BottomBar() {
  return (
    <>
      <div
        id="buttomBar"
        style={{
          width: '100%',
          maxHeight: '20px',
          minHeight: '20px',
          backgroundColor: '#0B0E13',
          position: 'fixed',
          bottom: 0,
          left: 0,
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingRight: 24,
        }}
      >
        {/* Left side: Development status indicators */}
        <div style={{ display: 'flex', alignItems: 'left', gap: '12px', paddingTop: '1px' }}>
          
          
          {/* Connection status indicator */}
          <img
            src="/Connect.png"
            alt="Connect Symbol"
            style={{ minHeight: '20px', height: '20px' }}
          />
          
          
          {/* Version control (Git) indicator */}
          <img
            src="/Version.png"
            alt="Versioning Symbol"
            style={{ minHeight: '18px', height: '18px', paddingTop: '1px' }}
          />
          <p style={{ margin: 0, color: '#565B4E' }}>main*</p>
          
          
          {/* Current Git branch with uncommitted changes indicator (*) */}
          <img
            src="/Sync.png"
            alt="Sync Symbol"
            style={{ minHeight: '15px', height: '15px', paddingTop: '2px' }}
          />

          
          {/* Error count indicator */}
          <img
            src="/Error.png"
            alt="Error Symbol"
            style={{ minHeight: '15px', height: '15px', paddingTop: '2px' }}
          />
          <p style={{ margin: 0, color: '#565B4E' }}>0</p>

          
          {/* Warning count indicator */}
          <img
            src="/Warning.png"
            alt="Warning Symbol"
            style={{ minHeight: '15px', height: '15px', paddingTop: '2px' }}
          />
          <p style={{ margin: 0, color: '#565B4E' }}>0</p>
        </div>
      </div>
    </>
  );
}

export default BottomBar;
